import { render, staticRenderFns } from "./vFormFORM_SUMMARY.vue?vue&type=template&id=10864364&"
import script from "./vFormFORM_SUMMARY.vue?vue&type=script&lang=js&"
export * from "./vFormFORM_SUMMARY.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports